// Auto-generated skeleton for CraftsmanTaskPersonContact

import { Person } from "./Person";
import { Unit } from "./Unit";
import { Role } from "./Role";

export const CraftsmanTaskPersonContact: Api.CraftsmanTaskPersonContact = {
  id: 0,
  person_id: 0,
  person: Person,
  unit_id: 0,
  unit: Unit,
  role_id: 0,
  role: Role,
  craftsman_task_person_id: 0,
  craftsman_task_person: null,
  person_type_id: 0,
  subject: '',
  created: null,
  updated: null,
};

